import { createFileRoute, redirect } from '@tanstack/react-router'
import { PayBillsScreen } from '@/features/accounting-bills/pay-bills-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/bills/pay')({
  validateSearch: (
    search: Record<string, unknown>,
  ): { billId?: string; purchaseOrderId?: string } => ({
    billId:
      typeof search.billId === 'string' && search.billId.length > 0 ? search.billId : undefined,
    // From an order's Pay bill: only that order's bills.
    purchaseOrderId:
      typeof search.purchaseOrderId === 'string' && search.purchaseOrderId.length > 0
        ? search.purchaseOrderId
        : undefined,
  }),
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_payment.create')) {
      throw redirect({ to: '/accounting/bills' })
    }
  },
  component: AccountingPayBillsRoute,
})

function AccountingPayBillsRoute() {
  const { billId, purchaseOrderId } = Route.useSearch()

  return <PayBillsScreen initialBillId={billId} purchaseOrderId={purchaseOrderId} />
}
